module.exports = __webpack_public_path__ + "img/Kh.a1d4e595.png";